"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconNextSizeVariant = exports.theme = void 0;
const component_theme_1 = require("@clds/component-theme");
const spacing = component_theme_1.globalTheme.spacing;
exports.theme = (0, component_theme_1.createTheme)({
    bySize: {
        xs: { width: spacing.xs },
        sm: { width: spacing.sm },
        md: { width: spacing.md },
        lg: { width: spacing.lg },
        xl: { width: spacing.xl },
        xxl: { width: spacing.xxl },
    },
});
exports.iconNextSizeVariant = (0, component_theme_1.createVariant)((props) => exports.theme.bySize[props.size]);
//# sourceMappingURL=theme.js.map